import { io } from "socket.io-client";

let socket = null;
const SOCKET_URL = process.env.REACT_APP_SOCKET_CONN_URL;

export const connectSocket = (userId) => {
  if (!socket && userId) {
    socket = io(SOCKET_URL, {
      query: { userId },
      autoConnect: true,
    });
  }
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
